import React, { useState, MouseEvent, KeyboardEvent } from 'react';
import { AppBar, Toolbar, IconButton, Button, Grid, Link, Drawer, List, ListItem, ListItemText,Hidden,useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from './assets/logo.png';
import whatsapp from './assets/whatsapp.png';
import { withTheme } from 'styled-components';
import { ThemeInterface } from '../../theme';

interface CabecalhoProps {
  theme: ThemeInterface;
}

function Cabecalho(props: CabecalhoProps) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);



  React.useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");

    // Define o tipo do parâmetro 'e' como MediaQueryListEvent
    const handleOrientationChange = (e: MediaQueryListEvent) => {
      setIsPortrait(e.matches);
    };

    // Adiciona um listener para mudanças na orientação
    mediaQuery.addEventListener('change', handleOrientationChange);

    // Limpa o listener quando o componente é desmontado
    return () => {
      mediaQuery.removeEventListener('change', handleOrientationChange);
    };
  }, []);

  const toggleDrawer = (open: boolean) => (event: MouseEvent | KeyboardEvent) => {
    if (event.type === 'keydown' && (event as KeyboardEvent).key === 'Tab' || (event as KeyboardEvent).key === 'Shift') {
      return;
    }
    setDrawerOpen(open);
  };

  const list = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
      {['Serviços', 'Sobre'].map((text, index) => (
    <Link href={text === 'Serviços' ? '/solicite-proposta' : '/sobre'} underline="none" color="inherit" key={text}>
      <ListItem button>
        <ListItemText primary={text} />
      </ListItem>
    </Link>
  ))}
      </List>
    </div>
  );
  

  return (
    <AppBar position="fixed" style={{ backgroundColor: props.theme.cores.primaria,  borderBottom: '2px solid white',display:'block' }}>
      <Toolbar>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Link href="/" underline="none">
              <img src={logo} alt="logo da empresa" style={{ height: "70px" }} />
            </Link>
          </Grid>

          <Grid item>
            {/* Logo para telas grandes (desktop) */}
            <Hidden smDown>
             
            </Hidden>
            {/* Logo para telas pequenas (celular) */}
            <Hidden mdUp>
            {isPortrait && (
          <a href="https://api.whatsapp.com/send?phone=5511983267276&text=&source=&data=" target="_blank" rel="noopener noreferrer">
            <img src={whatsapp} alt="logo do whatsapp" style={{ verticalAlign: 'middle', marginLeft: '15px' }} />
            <b style={{ color: 'white', marginLeft: '5px' }}> (11) 98326-7276</b>
          </a>
        )}
            </Hidden>
          </Grid>


          <Grid item sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Link href="/solicite-proposta" color="inherit" underline="none" sx={{ margin: '0 15px' }}>Serviços</Link>
            <Link href="/sobre" color="inherit" underline="none" sx={{ margin: '0 15px' }}>Sobre</Link>
            {/* <Button variant="contained" color="success" sx={{ borderRadius: 45, color: "#7bdcb5", marginLeft: '15px' }}  >
              Fale Conosco
            </Button> */}
            <a href="https://api.whatsapp.com/send?phone=5511983267276&text=&source=&data=" target="_blank" rel="noopener noreferrer">
              <img src={whatsapp} alt="logo do whatsapp" style={{ verticalAlign: 'middle', marginLeft: '15px' }} />
              <b style={{ color: 'white', marginLeft: '5px' }}> (11) 98326-7276</b>
            </a>
          </Grid>

          <Grid item sx={{ display: { xs: 'block', sm: 'none' } }}>
            <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
              {list()}
            </Drawer>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

export default withTheme(Cabecalho);;
